import React, {useState} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button, FormControlLabel, Checkbox } from '@mui/material';
import { useMutation } from "react-query";
import apiClient, { getCsrfCookie } from '../../request/http-common';
import { useDispatch } from 'react-redux';
import { setUser } from './userSlice';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAuthStatus, setToken } from '../../request/Auth/authSlice';

const Login = () => {
    const dispatch = useDispatch();
    const initialLogin = {
        email: '',
        password: '',
        remember_me: false,
    }
    const appMode = useSelector((state) => state.mode.mode);
    const redirectTo = useSelector((state) => state.redirect.redirect);
    const navigate = useNavigate();

    const [error, setErros] = useState('');
    const [registerForm, setRegisterForm] = useState(initialLogin);
    
    const onChange = (e) =>
    setRegisterForm({ ...registerForm, [e.target.name]: e.target.value });

    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(

        async () => {
          // Get CSRF cookie first
          await getCsrfCookie();
          
          return await apiClient.post(`/api/login`, {
            email: registerForm.email,
            password: registerForm.password,
            remember_me: registerForm.remember_me,
          });
        },
        {
          onSuccess: (res) => {
            // Store token and user data
            localStorage.setItem('auth-token', res.data.access_token);
            
            // If remember me is checked, also store in a persistent way
            if (registerForm.remember_me) {
              localStorage.setItem('remember-me', 'true');
              localStorage.setItem('user-data', JSON.stringify(res.data.user));
              // Set longer expiration for remember me (30 days)
              const expirationTime = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
              localStorage.setItem('auth-expiration', expirationTime.toString());
            } else {
              // Regular session - remove any remember me data
              localStorage.removeItem('remember-me');
              localStorage.removeItem('user-data');
              // Set shorter expiration (24 hours)
              const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000);
              localStorage.setItem('auth-expiration', expirationTime.toString());
            }
            
            dispatch(setUser(res.data.user));
            dispatch(setAuthStatus('authenticated'));
            dispatch(setToken(res.data.access_token));
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
            const event = new Event('newMessage');
            window.dispatchEvent(event);

            if (redirectTo !== '') {
              navigate(redirectTo);
            }else{
              window.location.href  = '/';
              
            }
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.message) 
            const event2 = new Event('processed');
            window.dispatchEvent(event2);      
          },
        }
      );
      const onSubmit = async() =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postLogin();
      } 

  return (
    <div style={{marginTop: '70px'}}>
        <Grid  container px={2} mt={4}  mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} md={5} sx={{display: {xs: 'none', md: 'flex'}}}>
              
            </Grid>
            <Grid item xs={12} md={4}>
            <Card className='box' sx={{marginX: '5px',  borderRadius: '9px'}}>
                    <CardContent>
                    <img  src={appMode === 'dark'? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754223144/logo_m53ie7.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754223144/logo_m53ie7.png'} style={{height: '53px', marginBottom: '20px'}} alt="BETA TRADES logo" />
                    <Divider />
                    <Typography mt={4} sx={{ fontWeight: 'bold', fontSize: 24, textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                        Login
                    </Typography>
                    <Typography  sx={{  textAlign: 'center', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        Fill the form below to login
                    </Typography>
                    
                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            {error !== '' ?
                            <OutlinedInput
                            error
                            onChange={onChange}
                            id="email"
                            type={'email'}
                            name="email"
                            label="Email"
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="email"
                            type={'email'}
                            name="email"
                            label="Email"
                            />
                             }
                                                        
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="password">Password</InputLabel>
                            {error !== '' ?
                            <OutlinedInput
                            error
                            onChange={onChange}
                            id="password"
                            name="password"
                            type={'password'}
                            label="Password"
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="password"
                            name="password"
                            type={'password'}
                            label="Password"
                            />
                            }
                        </FormControl>
                        
                        {/* Keep me logged in checkbox */}
                        <FormControl sx={{ m: 1 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={registerForm.remember_me}
                                        onChange={(e) => setRegisterForm({ ...registerForm, remember_me: e.target.checked })}
                                        name="remember_me"
                                        color="primary"
                                    />
                                }
                                label="Keep me logged in (30 days)"
                                sx={{ 
                                    '& .MuiFormControlLabel-label': { 
                                        fontSize: '14px',
                                        color: 'text.secondary'
                                    }
                                }}
                            />
                        </FormControl>
                        
                        <Typography color='error'  sx={{  textAlign: 'center', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error}
                        </Typography>
                        
                       
                        <Box mt={4} sx={{display: 'flex', justifyContent: 'space-evenly'}}>
                            <Link color="inherit"  to='/forgot' component={RouterLink} underline="none">
                            Forgot Password?
                            </Link>
                            <Link  to='/register' component={RouterLink} underline="none" color="inherit">
                            Register
                            </Link>
                        </Box>

                    </CardContent>
                    <CardActions>
                    <Button onClick={onSubmit} fullWidth={true} size="large" color="primary" variant="contained"> {isSendingRequest? 'Logging in...': 'Login'}</Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    </div>
  )
}

export default Login
